// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1702571466185
      var cssReload = require("/opt/homebrew/var/www/biokult/themes/bio-kult/_dev/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"sourceMap":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  